import React from "react";
import "./ColorSelector.css";
import {Tooltip} from "../common/Tooltip";

export const SelectableColors = [
    "#ffffff",
    "#000000",
    "#666666",
    "#cccccc",
    "#e6e6e6",

    "#b71c1c",
    "#d2302f",
    "#eb3529",
    "#f3928b",
    "#ffcdd2",

    "#e65100",
    "#f57c01",
    "#ff9802",
    "#ffb74e",
    "#ffcc80",

    "#fdd735",
    "#ffeb3b",
    "#ffef59",
    "#fff176",
    "#fff59d",

    "#33691e",
    "#689e39",
    "#8bc34a",
    "#aed581",
    "#c4e1a4",

    "#004d41",
    "#00796b",
    "#009588",
    "#4db5ab",
    "#7fcac3",


    "#0d47a0",
    "#1a76d2",
    "#2296f3",
    "#64b5f7",
    "#bbdefb",

    "#321b91",
    "#512da8",
    "#673bb7",
    "#9475cc",
    "#d1c4e9",

    "#3e2723",
    "#5e4037",
    "#795549",
    "#a1887f",
    "#d7ccc8",
] as const;

export type ColorType = typeof SelectableColors[number];

export function colorValues(): { [key: string]: string } {
    const m: { [key: string]: string } = {};
    SelectableColors.forEach(c => m[c] = c);
    return m;
}

type ColorSelectorProps = {
    onChange?: (color: string, e: React.MouseEvent<HTMLElement>) => void;
}

export const ColorSelector = (props: ColorSelectorProps) => {

    const [focusColor, setFocusColor] = React.useState('');

    return (
        <div className="color-selector">
            <div>
                {SelectableColors.map(color =>
                    <div key={color}
                         style={{backgroundColor: color}}
                         onMouseMove={() => setFocusColor(color)}
                         onClick={(e) => props.onChange?.(color, e)}
                    />
                )}
            </div>
            <span>{focusColor}</span>
        </div>
    );
}


type ColorSelectorButtonProps = {
    className?: string;
    tooltip?: string;
    disabled?: boolean;
    color?: string;
    onChange?: (color: string, e: React.MouseEvent<HTMLElement>) => void;
}

export const ColorSelectorButton = (props: ColorSelectorButtonProps) => {

    const className = props.className || '&nbsp;';
    const ariaDisabled = !!props.disabled;

    const [showSelector, setShowSelector] = React.useState<boolean>(false);

    const handleChange = (color: string, e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        handleClose();
        props.onChange?.(color, e);
    };

    const handleShow = (e: React.MouseEvent<HTMLElement>) => {
        if (props.disabled === true) {
            return;
        }
        setShowSelector(true);
    }
    const handleClose = () => {
        setShowSelector(false);
    }

    const fill_color = ariaDisabled ? '#ccc' : '#000';

    const selected_color = ariaDisabled
        ? '#ccc'
        : props.color !== undefined ? props.color : '#000';

    return (
        <div className="color-selector-container" onClick={e => e.preventDefault()} title={props.color}>
            <Tooltip title={props.tooltip || ''}>
                <div className={`color-selector-button ${className}`}
                     aria-disabled={ariaDisabled}
                     onClick={handleShow}
                >
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"
                         width="9px" height="14px" viewBox="0 0 9 14">
                        <g>
                            <path d="M3.196,0h1.607l2.926,8.84H6.255L5.511,6.321h-3.07L1.685,8.84H0.27L3.196,0z M2.765,5.229h2.41L4.827,4.042
                                C4.528,3.083,4.264,2.099,4,1.104H3.94C3.688,2.111,3.412,3.083,3.124,4.042L2.765,5.229z"
                                  fill={fill_color}/>
                            <rect y="10.84" width="8" height="2" fill={selected_color}/>
                        </g>
                    </svg>

                </div>
            </Tooltip>
            {showSelector && (
                <div className="color-selector-popover">
                    <div className="color-selector-cover" onClick={handleClose}/>
                    <ColorSelector onChange={handleChange}/>
                </div>
            )}
        </div>
    );
}
